module.exports = __webpack_public_path__ + "img/logo.98e96ae1.png";